// Copyright (c) 2026 杨翔宇（武汉文理学院）
// 物理智能教学智能体平台 (Physics Intelligent Agent)
// 保留所有权利 (All Rights Reserved)。未经著作权人书面许可，
// 不得以任何形式复制、传播、修改或用于商业用途。

export const RESEARCH_STUDIO_SURFACE = {
  key: 'research_studio',
  path: '/research-studio',
  label: 'Research Studio',
  description: '科研产品总台：统一总览工作台、记忆、写作与验收链路。',
} as const;
